import type { __SocialLinkType } from '../generated/graphql'

export function useSocialUrl(type: __SocialLinkType, handle: string | None): string | undefined {
  if (!handle?.length || !type) return
  switch (type) {
    case 'Instagram':
      return `https://www.instagram.com/${handle}/`
    case 'Pinterest':
      return `https://www.pinterest.com/${handle}/`
    case 'Tiktok':
      return `https://www.tiktok.com/@${handle}`
    case 'Twitter':
      return `https://twitter.com/${handle}`
    case 'Facebook':
      return `https://www.facebook.com/${handle}`
    case 'FbMessenger':
      return `https://m.me/${handle}`

    // https://open.spotify.com/show/4rOoJ6Egrf8K2IrywzwOMk
    // https://open.spotify.com/user/11120860022
    case 'Spotify':
      return `https://open.spotify.com/${handle}`

    // https://www.youtube.com/user/GEazyMusicVEVO
    case 'Youtube':
      return `https://www.youtube.com/${handle}`
    case 'Website':
      return `https://${handle}`
    default:
      return helpers.never(type, () => undefined)
  }
}

// const utm = '?utm_source=linenbylinas&utm_medium=social'

// export function useSocialUrl(type: SocialType, handle: string | None) {
//   const url = useSocialUrl2(type, handle)
//   if (!url?.length) return
//   return url + utm
// }
